import React from 'react';

import Checkbox from '../../../design-system/Checkbox/Checkbox';
import FormFieldWrapper from '../../../design-system/FormFieldWrapper/FormFieldWrapper';

const MultiSelectContentPiece = ({
    id,
    label,
    options,
    value,
    editable,
    setFormData,
    logFeedbackTrigger,
}) => {
    const handleMultiSelectChange = (id, optionValue) => {
        setFormData((prevData) =>
            prevData.map((item) => {
                if (item.id === id) {
                    const currentValue = Array.isArray(item.value) ? item.value : [item.value];
                    const newValue = currentValue.includes(optionValue)
                        ? currentValue.filter((el) => el !== optionValue)
                        : [...currentValue, optionValue];
                    return { ...item, value: newValue };
                } else {
                    return item;
                }
            })
        );
    };

    return (
        <FormFieldWrapper
            label={<strong>{label}</strong>}
            showLabelAsBadge
            gap={6}
            actionsBarRightContent={logFeedbackTrigger}
        >
            <ul className="flex flex-col gap-1">
                {Object.entries(options)?.map(([key, option], index) => (
                    <div key={index} className="py-1 px-2">
                        <Checkbox
                            isChecked={value.includes(option)}
                            name={option}
                            onChange={() => handleMultiSelectChange(id, option)}
                            label={key}
                            state={!editable ? 'disabled' : 'default'}
                        />
                    </div>
                ))}
            </ul>
        </FormFieldWrapper>
    );
};

export default MultiSelectContentPiece;
